/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPermsUserGroup.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/perms-user-group";

export class AutogenModelPermsUserGroup<RowType extends ModelRow> extends Endpoint<RowType, RowPermsUserGroupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPermsUserGroup extends ModelRow<RowPermsUserGroupFields> {
	constructor(values?: Partial<RowPermsUserGroupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPermsUserGroupFields {
	company_id: string;
	descr: string;
	group_membership: string;
	id: string;
	user_group_type: string;
	user_type: string;
}

